// Copyright (c) 2016 Deere & Company

import * as busyCounter from '../../../shared/action-creators/busy-counter';
import {
    filterCollection,
    sortCollection
} from '../../../shared/services/collections';
import {
    findSelectedObject,
    getMatchingObjects
} from '../../../shared/services/key-matcher';
import {
    getMetrics,
    getPipProducts,
    getPipTypes
} from '../../shared/repositories';
import actions from '../../actions-list';
import {buildPayload} from '../../shared/services/build-payload';
import filterOptions from '../../shared/constants/pip-products-filter-options';
import {readExcelLayouts} from '../../../shared/action-creators/read-excel-layouts';

export const readLaborAdditivePipsData = () =>

    async (dispatch, getState) => {

        dispatch(busyCounter.increaseBusyCounter());

        const facets = getState().pips.laborAdditive.facets;

        try {

            const excluded = await getMetrics();

            dispatch({
                data: excluded,
                type: actions.READ_SHOW_EXCLUDED_SUCCESS
            });

            const defaultFilters = {
                dealerAccountsFacet: {
                    allowedDealers: facets.dealerAccountsFacet.allowedDealers,
                    selectedDealers: facets.dealerAccountsFacet.isInitialLoad ?
                        facets.dealerAccountsFacet.allowedDealers :
                        facets.dealerAccountsFacet.selectedDealers
                },
                showExcludedFacet: {
                    allowedExcluded: excluded,
                    selectedExcluded: findSelectedObject('N', excluded)
                }
            };

            const payload = buildPayload(defaultFilters, 'LABORADDITIVE');

            const data = await getPipProducts(payload);

            dispatch({
                data,
                type: actions.READ_LABOR_ADDITIVE_PIP_PRODUCTS_SUCCESS
            });

        } catch (error) {

        } finally {

            dispatch(busyCounter.decreaseBusyCounter());

        }

    };

export const readOpenPipsData = facets =>

    async (dispatch, getState) => {

        dispatch(busyCounter.increaseBusyCounter());

        const {sortBy, sortDirection} = getState().pips.openPips.searchFilters;

        try {

            const pipTypes = await getPipTypes();

            dispatch({
                data: pipTypes,
                type: actions.READ_PIP_TYPES_SUCCESS
            });

            const metrics = await getMetrics();

            dispatch({
                data: metrics,
                type: actions.READ_METRICS_SUCCESS
            });

            const defaultFilters = {
                dealerAccountsFacet: {
                    allowedDealers: facets.dealerAccountsFacet.allowedDealers,
                    selectedDealers: facets.dealerAccountsFacet.isInitialLoad ?
                        facets.dealerAccountsFacet.allowedDealers :
                        facets.dealerAccountsFacet.selectedDealers
                },
                metricsFacet: {
                    allowedMetrics: metrics,
                    selectedMetrics: getMatchingObjects(['Y'], metrics)
                },
                pipTypesFacet: {
                    allowedTypes: pipTypes,
                    selectedTypes: getMatchingObjects([
                        'MALF',
                        'SAFT'
                    ], pipTypes)
                }
            };

            const payload = buildPayload(defaultFilters, 'OPEN');

            const data = await getPipProducts(payload);

            dispatch({
                data,
                type: actions.READ_OPEN_PIP_PRODUCTS_SUCCESS
            });

            dispatch({
                data: sortCollection(sortBy, sortDirection, data),
                type: actions.UPDATE_OPEN_PIP_PRODUCTS_FILTERED
            });

            if (!getState().exportToExcel.selectedExcelLayout.pipProducts.name) {

                readExcelLayouts('pipProducts')(dispatch);

            }

        } catch (error) {

        } finally {

            dispatch(busyCounter.decreaseBusyCounter());

        }

    };

export const readOpenPipProducts = facets =>

    async (dispatch, getState) => {

        dispatch(busyCounter.increaseBusyCounter());

        const {filterBy, sortBy, sortDirection} = getState().pips.openPips.searchFilters;

        const payload = buildPayload(facets, 'OPEN');

        try {

            const pipProducts = await getPipProducts(payload);

            dispatch({
                data: pipProducts,
                type: actions.READ_OPEN_PIP_PRODUCTS_SUCCESS
            });

            const sortedPipProducts = sortCollection(sortBy, sortDirection, pipProducts);
            const filteredPipProducts = filterCollection(filterBy, filterOptions, sortedPipProducts);

            dispatch({
                data: filteredPipProducts,
                type: actions.UPDATE_OPEN_PIP_PRODUCTS_FILTERED
            });

        } catch (error) {

            throw error;

        } finally {

            dispatch(busyCounter.decreaseBusyCounter());

        }

    };



// WEBPACK FOOTER //
// ./src/pip/open-pips/action-creators/open-pips.js